const isSelectCorrect = (answers: Array<Record<string, string>>) => {
  const arr = answers.filter((answer: Record<string, any>) => (answer.selected === true && answer.correct === true));
  // if selected answer has more than one correct answer and one is checked return true
  return arr.length > 0; // true or false
};

export default isSelectCorrect;
